var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center fill-height"},[_c('v-card',{attrs:{"loading":"","max-width":"600","min-width":"300","flat":"","rounded":""}},[_c('v-card-title',[_vm._v(" Logging you in... ")]),_c('v-card-text',[_c('div',[_vm._v("user id: "+_vm._s(_vm.userId))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }